<template>
  <svg
    width="165"
    height="116"
    viewBox="0 0 165 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M87.898 89.753c-2.584-13.037-4.8-20.3-6.645-21.79-2.769-2.235-7.752 5.029-8.86 6.146-1.107 1.117-8.306 10.057-5.537 13.409 1.846 2.235 5.168 5.773 9.967 10.615l11.075-8.38Z"
      fill="#F0B2A3"
    />
    <ellipse
      rx="9.309"
      ry="9.384"
      transform="matrix(.96051 -.27824 .27345 .96189 147.979 15.79)"
      fill="url(#a)"
      fill-opacity=".7"
    />
    <ellipse
      rx="9.309"
      ry="9.384"
      transform="matrix(.96051 -.27824 .27345 .96189 157.558 49.487)"
      fill="url(#b)"
      fill-opacity=".7"
    />
    <ellipse
      rx="9.309"
      ry="9.384"
      transform="matrix(.96051 -.27824 .27345 .96189 167.138 83.184)"
      fill="url(#c)"
      fill-opacity=".7"
    />
    <ellipse
      rx="9.309"
      ry="9.384"
      transform="matrix(.96051 -.27824 .27345 .96189 119.365 24.078)"
      fill="url(#d)"
      fill-opacity=".7"
    />
    <ellipse
      rx="9.309"
      ry="9.384"
      transform="matrix(.96051 -.27824 .27345 .96189 128.944 57.775)"
      fill="url(#e)"
      fill-opacity=".7"
    />
    <ellipse
      rx="9.309"
      ry="9.384"
      transform="matrix(.96051 -.27824 .27345 .96189 138.525 91.473)"
      fill="url(#f)"
      fill-opacity=".7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m83.188 29.786 30.827 13.209c1.657.71 2.43 2.642 1.727 4.314-.051.12-.109.238-.174.352l-5.107 8.985c-3.957 6.963-12.445 9.842-19.764 6.706l-8.585-3.679C75.077 56.66 71.794 48.46 74.78 41.358l4.133-9.829a3.248 3.248 0 0 1 4.274-1.743Z"
      stroke="url(#g)"
      stroke-width="7.638"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M94.517 34.64 63.69 21.433a3.248 3.248 0 0 0-4.404 2.113l-2.855 9.95c-2.213 7.71 1.631 15.874 8.951 19.01l8.585 3.679c7.035 3.014 15.158-.3 18.144-7.4l4.133-9.83c.703-1.672-.07-3.603-1.727-4.313Z"
      stroke="url(#h)"
      stroke-width="7.638"
    />
    <path
      d="m82.565 62.902-11.213-4.805-12.328 29.315 11.214 4.805 12.327-29.315Z"
      fill="#FF864C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M58.621 78.102 75.5 85.334a1.65 1.65 0 0 1 .863 2.157l-1.526 3.629-19.879-8.518 1.526-3.629a1.624 1.624 0 0 1 2.137-.871Z"
      fill="url(#i)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m54.076 80.403 22.94 9.83c1.97.844 2.89 3.14 2.053 5.128l-1.036 2.464c-.264.628-.981.92-1.603.654L48.607 86.557a1.238 1.238 0 0 1-.647-1.617l1.036-2.465c.836-1.988 3.11-2.916 5.08-2.072Z"
      fill="url(#j)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m75.218 17.267 33.248 14.246c1.657.71 2.43 2.641 1.726 4.314l-7.697 18.306c-4.6 10.94-17.116 16.045-27.954 11.4-10.838-4.643-15.895-17.277-11.294-28.217l7.697-18.306a3.248 3.248 0 0 1 4.274-1.743Z"
      fill="url(#k)"
    />
    <path
      d="M113.47 28.195 74.615 11.546a3.248 3.248 0 0 0-4.273 1.743l-.697 1.658c-.704 1.672.07 3.604 1.727 4.314l38.854 16.648c1.657.71 3.57-.07 4.274-1.743l.697-1.657c.703-1.673-.07-3.604-1.727-4.314Z"
      fill="#FFD37B"
    />
    <path
      d="m88.794 33.773.341 5.475a.62.62 0 0 0 .296.49l4.704 2.87c.435.267.382.914-.09 1.095l-5.102 1.963a.604.604 0 0 0-.373.428l-1.231 5.33a.61.61 0 0 1-1.07.242l-3.494-4.263a.62.62 0 0 0-.527-.225l-5.464.424a.618.618 0 0 1-.571-.945l2.942-4.597a.611.611 0 0 0 .047-.568l-2.145-5.067a.607.607 0 0 1 .717-.826l5.312 1.421a.61.61 0 0 0 .556-.126l4.138-3.555a.618.618 0 0 1 1.014.434Z"
      fill="white"
      stroke="white"
      stroke-width="5.092"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M89.602 87.796c0-6.394-.292-10.463-.875-12.206-.876-2.616-2.627-5.232-2.627-8.72 0-3.487 0-7.846-.875-7.846-.876 0-5.253 2.615-6.128 6.975-.876 4.36.875 4.36 0 5.231-.876.872-3.502 2.616-4.378 8.719-.875 6.103 7.004 10.463 7.88 11.335.583.58 2.918-.582 7.003-3.488ZM69.96 60.975l6.019 2.014a2.526 2.526 0 0 1 1.594 3.158 2.531 2.531 0 0 1-3.121 1.681l-5.96-1.742a1.647 1.647 0 0 1-1.125-1.99l.502-1.97a1.628 1.628 0 0 1 2.091-1.151Z"
      fill="#FFD4C3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m66.692 67.772 1.365-1.191a1.923 1.923 0 0 1 2.723.191l4.592 5.3a2.78 2.78 0 0 1-.259 3.898l-.011.01a2.798 2.798 0 0 1-3.93-.241l-4.647-5.177a1.966 1.966 0 0 1 .167-2.79Z"
      fill="#FFD4C3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m62.404 71.047 1.346-1.138a1.922 1.922 0 0 1 2.7.213l3.68 4.25a2.525 2.525 0 0 1-.234 3.54l-.01.01a2.698 2.698 0 0 1-3.677-.115l-3.916-3.865a1.967 1.967 0 0 1 .11-2.895Z"
      fill="#FFD4C3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m58.2 74.595.728-1.038a1.924 1.924 0 0 1 2.7-.465l3.585 2.57a2.292 2.292 0 0 1 .443 3.296 2.689 2.689 0 0 1-3.555.578L58.74 77.37a1.965 1.965 0 0 1-.539-2.775Z"
      fill="#FFD4C3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M79.156 117.409c1.67.838 13.452.849 20.6 0 4.094.745 14.093.745 27.718 0-9.598-1.117-20.96-9.312-32.455-21.79-2.226-2.235-9.462 1.676-21.707 11.733 2.783 6.146 4.731 9.498 5.844 10.057Z"
      fill="#FD6565"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m95.915 87.333 2.697 5.807c.717 1.543.059 3.38-1.469 4.103l-.012.005-23.208 10.864a3.044 3.044 0 0 1-4.052-1.489l-2.698-5.808c-.716-1.542-.058-3.379 1.47-4.102l.011-.005 23.209-10.864a3.043 3.043 0 0 1 4.052 1.489ZM136.385 64.094c-2.143.289-3.588-.502-4.337-2.371-1.122-2.804.56-5.059 1.812-3.938 1.252 1.12-.539 2.666.022 4.068.374.935 1.209 1.682 2.503 2.241ZM137.761 64.138c4.422-1.241 7.546-.264 9.371 2.93 2.738 4.793 1.495 7.832-.205 7.681-1.7-.15-3.316-1.282-2.448-4.066.869-2.784-1.037-4.642-3.028-5.518-1.327-.584-2.557-.927-3.69-1.027Z"
      fill="#FFD37B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.972 63.402c-.665 3.805-2.62 5.708-5.865 5.708-4.869 0-7.525-4.51-5.09-5.708C3.45 62.204 4.668 65.8 7.103 65.8c1.623 0 3.245-.799 4.869-2.397ZM13.089 60.89c.823-7.337 4.116-11.413 9.88-12.228 8.643-1.223 11.72 2.373 11.113 4.892-.606 2.518-5.276 3.328-7.41 1.222-2.133-2.105-7.409-1.223-9.878 1.223-1.647 1.63-2.882 3.261-3.705 4.891Z"
      fill="#FF89E3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M122.673 16.879c.522 2.104.261 3.156-.784 3.156 1.045.526 3.134 2.367 6.268 5.523 1.567-2.104 1.828-3.945.784-5.523-1.567-2.367-2.351-5.523-4.701-5.523-1.567 0-2.873.263-3.918.789l2.351 1.578Z"
      fill="url(#l)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M109.354 19.246c5.224-6.312 8.88-9.205 10.969-8.68 3.134.79 8.619 8.68 8.619 9.469-3.134-2.367-4.701-4.734-7.835-3.945-3.134.789-10.186 4.734-10.969 3.945l-.784-.79Z"
      fill="#B787FD"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M96.52 17.566c3.055-6.53 3.819-11.052 2.291-13.563C96.52.235 93.464-.518 93.464 2.496c0 3.014 1.528 6.028 1.528 9.796 0 3.767 0 6.028.764 6.028.509 0 .763-.251.763-.754Z"
      fill="#F13F5A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M45.797 15.852c-1.07-4.72-1.338-8.655-.803-11.802-3.213-.787-7.23 2.36-6.426 3.934.535 1.05 2.945 3.672 7.23 7.868Z"
      fill="#FFB360"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.945 23.666c-1.553-4.79-3.366-7.45-5.437-7.983-3.108-.798-4.661 0-7.768-1.597-3.108-1.596-5.438-3.991-6.215-3.991-.777 0-2.33 3.991-1.553 7.983.776 3.992 2.33 5.588 5.437 5.588s8.545-3.992 11.652-2.395c2.072 1.065 3.366 1.863 3.884 2.395Z"
      fill="#6EFFEE"
    />
    <defs>
      <linearGradient
        id="a"
        x1="9.309"
        y1="0"
        x2="9.309"
        y2="18.767"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#91DFBC" />
        <stop offset="1" stop-color="#C0FFE3" stop-opacity=".4" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="9.309"
        y1="0"
        x2="9.309"
        y2="18.767"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#91DFBC" />
        <stop offset="1" stop-color="#C0FFE3" stop-opacity=".4" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="9.309"
        y1="0"
        x2="9.309"
        y2="18.767"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#91DFBC" />
        <stop offset="1" stop-color="#C0FFE3" stop-opacity=".4" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="9.309"
        y1="0"
        x2="9.309"
        y2="18.767"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#91DFBC" />
        <stop offset="1" stop-color="#C0FFE3" stop-opacity=".4" />
      </linearGradient>
      <linearGradient
        id="e"
        x1="9.309"
        y1="0"
        x2="9.309"
        y2="18.767"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#91DFBC" />
        <stop offset="1" stop-color="#C0FFE3" stop-opacity=".4" />
      </linearGradient>
      <linearGradient
        id="f"
        x1="9.309"
        y1="0"
        x2="9.309"
        y2="18.767"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#91DFBC" />
        <stop offset="1" stop-color="#C0FFE3" stop-opacity=".4" />
      </linearGradient>
      <linearGradient
        id="g"
        x1="100.686"
        y1="39.362"
        x2="91.017"
        y2="58.129"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD37B" />
        <stop offset="1" stop-color="#F38544" />
      </linearGradient>
      <linearGradient
        id="h"
        x1="57.288"
        y1="28.238"
        x2="71.676"
        y2="42.252"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFDD98" />
        <stop offset="1" stop-color="#F38544" />
      </linearGradient>
      <linearGradient
        id="i"
        x1="61.686"
        y1="80.089"
        x2="86.815"
        y2="90.655"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFCD78" />
        <stop offset="1" stop-color="#FFA351" />
      </linearGradient>
      <linearGradient
        id="j"
        x1="48.126"
        y1="81.863"
        x2="61.095"
        y2="96.083"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFCD78" />
        <stop offset="1" stop-color="#FFA351" />
      </linearGradient>
      <linearGradient
        id="k"
        x1="69.455"
        y1="26.559"
        x2="100.275"
        y2="56.9"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFCD78" />
        <stop offset="1" stop-color="#FFA351" />
      </linearGradient>
      <linearGradient
        id="l"
        x1="125.842"
        y1="16.144"
        x2="123.633"
        y2="23.353"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7E3BE0" />
        <stop offset="1" stop-color="#A86CFF" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
@Component
export default class CupIcon extends Vue {}
</script>
